import React from 'react';
import {Tooltip} from 'components/Tooltip';
import {getStrategyLeagues, getStrategyMarkets, getTooltipStrategyLeagues} from '../../helpers';

const StrategyConfiguration = ({strategy}) => (
  <div className="strategy-details first">
    <div className="strategy-stat markets">
      <div className="stat-title">Markets</div>
      <div className="stat-value">{getStrategyMarkets(strategy)}</div>
    </div>
    <div className="strategy-stat leagues">
      <div className="stat-title">Leagues</div>
      {strategy.leagues.length >= 2 ? (
        <Tooltip text={getTooltipStrategyLeagues(strategy)} layout="column">
          <div className="stat-value">{getStrategyLeagues(strategy)}</div>
        </Tooltip>
      ) : (
        <div className="stat-value">{getStrategyLeagues(strategy)}</div>
      )}
    </div>
  </div>
);

export default StrategyConfiguration;
